import * as React from 'react';
import css from '../ReliabilityScore.scss';
import { CloseButtonProps } from '../types/reliabilityScore.type';
import { CLOSE_BUTTON_CONFIG } from '../config';

const CloseButton = (props: CloseButtonProps): JSX.Element => {
  const { onClose } = props;
  return (
    <div className={css['button-container']}>
      <button className={css['close-button']} style={{ backgroundColor: CLOSE_BUTTON_CONFIG.COLOR }} onClick={onClose} type="button">
        {CLOSE_BUTTON_CONFIG.CLOSE}
      </button>
    </div>
  );
};

export default CloseButton;
